import { BreakpointTrackerContext } from '@jutro/layout';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import _ from 'lodash';
import React, { useCallback, useContext, useEffect, useState } from 'react';
import StructureTypeUtil from '../../../util/StructureTypeUtil';
import TWIACleanseObjUtil from '../../../util/TWIACleanseObjUtil';
import metadata from './PrimaryPolicyDetails.metadata.json5';
import styles from './PrimaryPolicyDetails.module.scss'

function PrimaryPolicyDetails(props) {
    const breakpoint = useContext(BreakpointTrackerContext);
    const { submissionVM, yourHomeVM, updateSubmissionVM,
        showErrors, findInvalidComponent, onValidate } = props;
    const [disableConsent, setDisableConsent] = useState(false);
    const viewModelService = useContext(ViewModelServiceContext);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const structureCodes = ['1Family', '2Family', 'DwellingOutBuild',
        'IndividuallyTH', 'PublicHousing'];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [policyTypeCode, setPolicyTypeCode] = useState(submissionVM.lobData
        .homeowners.policyType_TWIA.value.code);
    const PRIMARY_POLICY_COMPONENT = 'PrimaryPolicyDetails';
    const { onValidate: setComponentValidation, isComponentValid } = useValidation(PRIMARY_POLICY_COMPONENT);

    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, PRIMARY_POLICY_COMPONENT);
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, PRIMARY_POLICY_COMPONENT);
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        StructureTypeUtil.structureTypeDetail(yourHomeVM, submissionVM.lobData.homeowners,
            policyTypeCode, viewModelService);

        // eslint-disable-next-line no-secrets/no-secrets
        const companionPolicy = _.get(yourHomeVM, 'haveCompanionPolicy_TWIA.value');

        if (companionPolicy && needConsequentlLosCovTwia()) {
            _.set(yourHomeVM, 'needConsequentlLosCov_TWIA.value', true);
        }
    }, []);

    const needConsequentlLosCovTwia = useCallback(() => {
        if (yourHomeVM.haveCompanionPolicy_TWIA.value) {
            switch (policyTypeCode) {
                case 'TWRD':
                    // eslint-disable-next-line no-case-declarations
                    const structureTypeCode = _.get(yourHomeVM.value, 'structureType_TWIA.code')
                        || _.get(yourHomeVM.value, 'structureType_TWIA');

                    return _.includes(structureCodes, structureTypeCode);
                case 'TWRC':
                    return true;
                case 'TWRP':
                    return true;
                default:
                    return false;
            }
        }

        return false;
    }, [policyTypeCode, structureCodes, yourHomeVM]);

    const writeValue = useCallback((value, path) => {
        // eslint-disable-next-line no-secrets/no-secrets
        if (_.includes(path, 'haveCompanionPolicy_TWIA')) {
            TWIACleanseObjUtil.resetAspectsNotVisibleValues(yourHomeVM);

            if (value && needConsequentlLosCovTwia()) {
                _.set(yourHomeVM, 'needConsequentlLosCov_TWIA.value', true);
                setDisableConsent(true);
            } else {
                setDisableConsent(false);
            }
        }

        _.set(yourHomeVM, path, value);
        updateSubmissionVM(yourHomeVM);
    }, [needConsequentlLosCovTwia, updateSubmissionVM, yourHomeVM]);

    const structureType = _.get(yourHomeVM, 'structureType_TWIA.value.code');
    const policyType = _.get(submissionVM, 'lobData.homeowners.policyType_TWIA.value.code'); 
    const dwellingUsage =_.get(yourHomeVM, 'dwellingUsage.value.code') === 'sec'
    
    const overrideProps = {
        '@field': {
            // apply to all fields
            // showOptional: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        coveragePerils: {
            // eslint-disable-next-line no-secrets/no-secrets
            visible: _.get(yourHomeVM, 'haveCompanionPolicy_TWIA.value') === true
        },
        consequentialLoss: {
            disabled: disableConsent || needConsequentlLosCovTwia()
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {},
        resolveCallbackMap: {

        },
    };

    return (

        <ViewModelForm
            uiProps={metadata.pageContent}
            model={yourHomeVM}
            showErrors={showErrors}
            overrideProps={overrideProps}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />

    );
}

PrimaryPolicyDetails.propTypes = wizardProps;
export default PrimaryPolicyDetails;
